export const Practice = {
  PRIMARY: "Primary",
  SECONDARY: "Secondary",
  SAP: "Surgical Prophylaxis",
} as const;

export const Patient = {
  ADULT: "Adult",
  CHILD: "Pediatric",
} as const;

export const SHORT_FORM_CONFIG: Record<string, string> = {
  "#RASH": "Minor rash, without urticaria or mucosal involvement",
  "#SPOT": "Minor rash, without urticaria or mucosal involvement",
  "#ANAPHYLAXIS": "Urticaria, angioedema or anaphylaxis",
  "#SCAR":
    "Severe non immediate hypersensitivity reaction e.g. Stevens-Johnson syndrome, toxic epidermal necrolysis, DRESS",
  "#ALLERGYQ": "What is the nature of the penicillin allergy?",  
  "#IMMED": "Urticaria, angioedema or anaphylaxis",
  "#PSCAR":
    "Severe non immediate hypersensitivity reaction e.g. Stevens-Johnson syndrome, toxic epidermal necrolysis, DRESS",
  "#CRITICAL": "Critical illness requiring intensive care level support",
  "CRITICAL": "Critical illness requiring intensive care level support",
  "CRITICAL ILLNESS": "Critical illness requiring intensive care level support",
  "YOU CAN SELECT MORE THAN ONE": "Select all that apply",
  "MRSA COLONISED": "MRSA colonised (any positive culture within 2 years)",
};

export const BACK_POCKET_PRESCRIPTION_MAP: Record<string, string[]> = {
  // AOM (Acute Otitis Media) - No antibiotics → Mild AOM requiring antibiotics
  "998f793f-5976-4736-9f97-ae515d1eb3bf": [
    "71ecf41e-5f46-48bd-a227-7280dac1e6c4", // Primary option
    "0b1e4af7-c744-4c51-a4e0-263f08c7acaf"  // Alternative (allergy pathway)
  ],
  
  // Add additional mappings here as needed
  // Format:
  // "no-antibiotics-recommendation-id": [
  //   "treatment-recommendation-id-1",
  //   "treatment-recommendation-id-2" // optional alternative
  // ],
};

//Helper function to check if a recommendation has back-pocket prescriptions
export const hasBackPocketPrescription = (recommendationId: string): boolean => {
  return recommendationId in BACK_POCKET_PRESCRIPTION_MAP;
};

//Helper function to get back-pocket prescription IDs for a recommendation
export const getBackPocketPrescriptionIds = (recommendationId: string): string[] => {
  return BACK_POCKET_PRESCRIPTION_MAP[recommendationId] || [];
};